import { render, staticRenderFns } from "./FeedBackMain.vue?vue&type=template&id=d4992300&scoped=true"
import script from "./FeedBackMain.vue?vue&type=script&lang=ts"
export * from "./FeedBackMain.vue?vue&type=script&lang=ts"
import style0 from "./FeedBackMain.vue?vue&type=style&index=0&id=d4992300&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d4992300",
  null
  
)

export default component.exports